// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleNosToHeadMappingVO')
export class ArticleNosToHeadMappingVO {
  @JsonProperty('providedArticleNos', '[String]')
  public providedArticleNos: string[] = undefined;

  @JsonProperty('articles', '[ArticleVO]')
  public articles: ArticleVO[] = undefined;

  @JsonProperty('nonExistingArticleNos', '[String]')
  public nonExistingArticleNos: string[] = undefined;

  @JsonProperty('isFirstArticleMarkingSystemArticle', 'Boolean')
  public isFirstArticleMarkingSystemArticle: boolean = undefined;

  @JsonProperty('isFirstArticleMCSArticle', 'Boolean')
  public isFirstArticleMCSArticle: boolean = undefined;

  @JsonProperty('isFirstArticleGDSArticle', 'Boolean')
  public isFirstArticleGDSArticle: boolean = undefined;

}
